module.exports = __webpack_public_path__ + "static/media/lu.cad8b8ba.svg";